import { render, staticRenderFns } from "./Reviewslist.vue?vue&type=template&id=089e0bf2&scoped=true"
import script from "./Reviewslist.vue?vue&type=script&lang=js"
export * from "./Reviewslist.vue?vue&type=script&lang=js"
import style0 from "./Reviewslist.vue?vue&type=style&index=0&id=089e0bf2&prod&lang=css"
import style1 from "./Reviewslist.vue?vue&type=style&index=1&id=089e0bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e0bf2",
  null
  
)

export default component.exports